import backendHttpClient from '@services/_httpClient/backend.http-client';

import { SessionsRepository } from './repository';
import type { CurrentSession } from './types/session.type';

class SessionsService extends SessionsRepository {
  public async getCurrent(): Promise<CurrentSession> {
    const response = await backendHttpClient.get<CurrentSession>({
      path: '/sessions',
    });

    return response.data;
  }
}

export const sessionsService = new SessionsService();
